import React from "react";
import { Box, Grid, Typography } from "@mui/material";

export default function DetailPanels({ panels = [] }) {
  return (
    <Box component="section" sx={{ bgcolor: "#F1F5F9", py: 12 }}>
      <Box sx={{ maxWidth: 1280, mx: "auto", px: { xs: 2, md: 4 } }}>
        <Grid container spacing={3}>
          {panels.map(([title, copy, Icon]) => (
            <Grid item xs={12} md={4} key={title}>
              <Box sx={{
                bgcolor: "white", borderRadius: 3.5, p: 3.5,
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)", height: "100%",
              }}>
                <Icon size={30} color="#2A8DFF" style={{ marginBottom: 16 }} />
                <Typography variant="h6" fontWeight={700} gutterBottom>{title}</Typography>
                <Typography variant="body2" color="text.secondary" lineHeight={1.8}>{copy}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}